import {FC, PropsWithChildren} from 'external/react'

import ButtonBackContainer from './ButtonBackContainer'

const PaymentHistoryContainer: FC<PropsWithChildren> = props => {
    const {children} = props
    return (<ButtonBackContainer backTo='/home/payment' iconName='faClockRotateLeft' label='Historial de Pagos'>{children}</ButtonBackContainer>)
}

export {PaymentHistoryContainer as default}